// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"5eb73cdc","154":"9c4e5230","260":"8152e65d","596":"57e87ee1","725":"048323e5"}[chunkId] + ".chunk.js";
};